/**
 * Guard for the `speechki-token-expired` postMessage to the embedding Platform.
 * Platform answers with a new link and reloads the iframe, so without a guard a
 * permanently failing token would loop forever. The throttle lives in
 * localStorage (survives the iframe reload and sessionStorage.clear()).
 */
export const TOKEN_EXPIRED_THROTTLE_MS = 10 * 60 * 1000;

let postedThisPageLoad = false;

export function resetTokenExpiredPageFlag() {
    postedThisPageLoad = false;
}

export function getEmbedBookId() {
    const match = /\/embed\/([^/?#]+)/.exec(window.location.pathname || '');
    return match ? match[1] : 'unknown';
}

/**
 * @returns {boolean} true if the message was posted, false if suppressed
 */
export function notifyTokenExpired(bookId = getEmbedBookId(), detail = 'Access token expired') {
    if (postedThisPageLoad) return false;

    const key = `speechki:token-expired:${bookId}`;
    const now = Date.now();

    try {
        const last = Number(localStorage.getItem(key));
        if (last && now - last >= 0 && now - last < TOKEN_EXPIRED_THROTTLE_MS) return false;
        localStorage.setItem(key, String(now));
    } catch {
        // storage unavailable: fall back to once per page load
    }

    postedThisPageLoad = true;

    if (window.parent && window.parent !== window) {
        window.parent.postMessage({ event: 'speechki-token-expired', data: { detail } }, '*');
    }

    return true;
}
